<template>
  <div
    class="absolute bottom-full right-0 mb-2 bg-white rounded-lg shadow-xl border border-gray-200 min-w-[200px] overflow-hidden z-[99999]"
  >
    <div class="py-2">
      <button
        @click="handleAction('report')"
        class="w-full px-4 py-2 text-left hover:bg-gray-100 flex items-center gap-2 text-sm text-gray-700 transition-colors"
      >
        <Bug class="w-4 h-4" />
        Remonter un bug
      </button>
      <button
        @click="handleAction('list')"
        class="w-full px-4 py-2 text-left hover:bg-gray-100 flex items-center gap-2 text-sm text-gray-700 transition-colors"
      >
        <List class="w-4 h-4" />
        Voir mes remontées
      </button>
      <div class="border-t border-gray-200 my-1"></div>
      <button
        @click="handleClearCache"
        class="w-full px-4 py-2 text-left hover:bg-gray-100 flex items-center gap-2 text-sm text-gray-700 transition-colors"
      >
        <Trash2 class="w-4 h-4" />
        Vider les caches
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { cacheService } from '@/services/cacheService'
import { useBlogStore } from '@/stores/blog'
import { useGraffitiStore } from '@/stores/graffiti'
import { Bug, List, Trash2 } from 'lucide-vue-next'

const emit = defineEmits<{
  close: []
  action: [action: string]
}>()

function handleAction(action: string) {
  console.log('[BdC-BugTrackerMenu] Action sélectionnée:', action)
  emit('action', action)
  emit('close')
}

async function handleClearCache() {
  console.log('[BdC-BugTrackerMenu] Vidage de tous les caches...')

  try {
    // Vider le cache du service de cache
    cacheService.invalidateAll()

    // Vider les caches des stores Pinia
    const graffitiStore = useGraffitiStore()
    graffitiStore.invalidateAllCaches()

    const blogStore = useBlogStore()
    blogStore.invalidateAllCaches()

    // Vider le localStorage (caches persistants)
    const keysToRemove: string[] = []
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i)
      if (key && (key.startsWith('bdc-') || key.startsWith('graffiti-'))) {
        keysToRemove.push(key)
      }
    }
    keysToRemove.forEach(key => localStorage.removeItem(key))

    console.log('[BdC-BugTrackerMenu] Caches vidés avec succès')
    alert('Tous les caches ont été vidés avec succès. La page va se recharger.')

    // Recharger la page pour forcer le rechargement des données
    window.location.reload()
  } catch (error) {
    console.error('[BdC-BugTrackerMenu] Erreur lors du vidage des caches:', error)
    alert('Erreur lors du vidage des caches. Voir la console pour plus de détails.')
  }

  emit('close')
}
</script>
